import { useIsAuthenticated } from "@podcasts/hooks"

export const AuthGuard = ({ children, instead = null }: any) => {
  const isAuthenticated = useIsAuthenticated()

  return <>{isAuthenticated ? children : instead}</>;
};
